import type { ArticleType } from './articles';
import { advisoryArticles, xingAdvisoryArticles } from './articles';
import { coverLetterArticles } from './cover-letter-articles';

export const getAdvisoryArticles = (
  isCoverLetterRoot: boolean,
  isCrateApp: boolean
): ArticleType[] => {
  if (isCoverLetterRoot) {
    return coverLetterArticles;
  }

  if (isCrateApp) {
    return xingAdvisoryArticles;
  }

  return advisoryArticles;
};
